import api from "./api";
import {
  FindSystemModuleResponse,
  ListSystemModulesResponse,
  SaveSystemModulePayload,
  SystemModuleDetails,
} from "../types/SystemModule";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token não encontrado");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

export async function findAllModules(params?: {
  active?: boolean;
  search?: string;
}): Promise<ListSystemModulesResponse> {
  const response = await api.get<ListSystemModulesResponse>("/modules", {
    params,
    headers: getAuthHeaders(),
  });

  return response.data;
}

export async function findModule(
  moduleId: string | number,
): Promise<SystemModuleDetails> {
  const response = await api.get<FindSystemModuleResponse>(
    `/modules/${moduleId}`,
    {
      headers: getAuthHeaders(),
    },
  );

  return response.data.data;
}

export async function createModule(
  payload: SaveSystemModulePayload,
): Promise<void> {
  await api.post("/modules", payload, {
    headers: getAuthHeaders(),
  });
}

export async function updateModule(
  moduleId: string | number,
  payload: SaveSystemModulePayload,
): Promise<void> {
  await api.put(`/modules/${moduleId}`, payload, {
    headers: getAuthHeaders(),
  });
}

export async function deleteModule(moduleId: string | number): Promise<void> {
  await api.delete(`/modules/${moduleId}`, {
    headers: getAuthHeaders(),
  });
}
